export const SECTIONS = {
  POLICY_INFORMATION: 1,
  INSURANCE_COMPANY_INFORMATION: 2,
  APPLICANT: 3,
  POLICY_PERIOD: 4,
  VEHICLES: 5,
  DRIVERS: 6,
  CLAIMS: 7,
  CONVICTIONS: 8,
  RATING_INFORMATION: 9,
  INSURANCE_COVERAGES: 10,
  METHOD_OF_PAYMENT: 11,
  REPORT_OF_BROKER_AGENT: 12,
  REMARKS: 13,
  AKNOWLEDGEMENT: 14,
  DISCLOSURE_AND_ATTESTATION: 15,
};

export const MULTI_LINE_DISCOUNT_VALIDATION_ID = '098';
export const PROPERTY_BINDER_NUMBER_LABEL = 'Property Binder Number';
export const MULTI_LINE_DISCOUNT_ITEM_KEY = 'global';
export const PROPERTY_BINDER_NUMBER_PATTERN =
  /^(?=.*\d)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/;

export const SECTIONS_MENU = [
  {
    name: 'Policy Information',
    link: 'sectionPolicyInformation',
    section: SECTIONS.POLICY_INFORMATION,
  },
  {
    name: 'Insurance Company and Broker Information',
    link: 'sectionInsuranceCompanyInformation',
    section: SECTIONS.INSURANCE_COMPANY_INFORMATION,
  },
  {
    name: "Applicant's Name & Primary Address",
    link: 'sectionApplicant',
    section: SECTIONS.APPLICANT,
  },
  {
    name: 'Policy Period',
    link: 'sectionPolicyPeriod',
    section: SECTIONS.POLICY_PERIOD,
  },
  {
    name: 'Described Automobile',
    link: 'sectionVehicles',
    section: SECTIONS.VEHICLES,
  },
  {
    name: 'Driver Information',
    link: 'sectionDrivers',
    section: SECTIONS.DRIVERS,
  },
  {
    name: 'Accidents and Claims Summary',
    link: 'sectionClaims',
    section: SECTIONS.CLAIMS,
  },
  {
    name: 'Convictions Summary',
    link: 'sectionConvictions',
    section: SECTIONS.CONVICTIONS,
  },
  {
    name: 'Rating Information',
    link: 'sectionRatingInformation',
    section: SECTIONS.RATING_INFORMATION,
  },
  {
    name: 'Insurance Coverages',
    link: 'sectionInsuranceCoverages',
    section: SECTIONS.INSURANCE_COVERAGES,
  },
  {
    name: 'Method of Payment',
    link: 'sectionMethodOfPayment',
    section: SECTIONS.METHOD_OF_PAYMENT,
  },
  {
    name: 'Report of Broker Agent',
    link: 'sectionReportOfBrokerAgent',
    section: SECTIONS.REPORT_OF_BROKER_AGENT,
  },
  {
    name: 'Remarks',
    link: 'sectionRemarks',
    section: SECTIONS.REMARKS,
  },
  {
    name: 'Acknowledgement',
    link: 'sectionAcknowledgement',
    section: SECTIONS.AKNOWLEDGEMENT,
  },
  {
    name: 'Disclosure and Attestation',
    link: 'sectionDisclosureAndAttestation',
    section: SECTIONS.DISCLOSURE_AND_ATTESTATION,
  },
];
